import React from "react";
import { Notification } from "react-admin";

const uNotification = (props) => {
  return <Notification {...props} autoHideDuration={0} />; // 0 seconds
};

export default uNotification;
